import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Chart from "react-apexcharts";

export default function ChatDevices(props: any) {
  const { DevicesData } = props;

  DevicesData &&
    DevicesData.length > 0 &&
    DevicesData.sort(function (a: any, b: any) {
      return a.device.localeCompare(b.device);
    });
  const devicenameArray: any[] = [];
  const deviceCountArray: any[] = [];
  const devicenameFormatArray: any[] = [];

  DevicesData &&
    DevicesData.map((e: any) => {
      devicenameArray.push(e.device.toLowerCase());
      devicenameFormatArray.push(e.device);
      deviceCountArray.push(e.count);
    });

  const colorArray: any[] = [];
  if (devicenameArray && devicenameArray.length > 0) {
    if (devicenameArray.includes("android")) {
      colorArray.push("#FEC163");
    }
    if (devicenameArray.includes("ios")) {
      colorArray.push("#AEE4A1");
    }
    if (devicenameArray.includes("web")) {
      colorArray.push("#2858D3");
    }
  }
  const series = deviceCountArray;

  const data: any = {
    options: {
      chart: {
        events: {
          mounted: (chart: any) => {
            chart.windowResizeHandler();
          },
        },
        // width: 380,
        type: "pie",
      },
      labels: devicenameFormatArray,
      //FEC163 yello - android
      //2858D3 blue - web
      //AEE4A1 green -  ios
      colors: colorArray,
      fill: {
        colors: colorArray,
      },
      legend: {
        markers: { shape: "square" },
        position: "bottom",
        horizontalAlign: "center",
        // offsetY: 5,
        // fontWeight: "bold",
        fill: {
          colors: colorArray,
        },
      },
      // plotOptions: {
      //   pie: {
      //     dataLabels: {
      //       offset: -10,
      //     },
      //   },
      // },
      plotOptions: {
        pie: {
          dataLabels: {
            offset: -10,
            textAnchor: "middle",
            minAngleToShowLabel: 15,
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -50,
        alignTo: "connectors",
        formatter: function (val: any, opts: any) {
          return opts.w.config.series[opts.seriesIndex];
        },
      },
      responsive: [
        {
          breakpoint: 1000,
          options: {},
        },
      ],
    },
  };

  return (
    <Grid
      sx={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <Typography className="repu-heading">
        <Typography
          sx={{ fontWeight: 700, fontSize: "13px", textTransform: "uppercase" }}
        >
          Devices
          {/* <Avatar
            sx={{
              height: "35px",
              width: "35px",
              marginLeft: "5px",
              fontSize: "10px",
              background: "#2858D3",
              display: "inline-flex",
              border: "1px solid #FFF",
            }}
          >
            {ReportsTicketsTopfiveCount}
          </Avatar> */}
        </Typography>
        {/* <Typography
          sx={{
            color: "#2858D3",
            fontWeight: 700,
            fontSize: "13px",
            cursor: "pointer",
          }}
          component="div"
          // onClick={() => handleRedirectUncategorisedTickets()}
        >
          VIEW ALL
        </Typography> */}
      </Typography>

      <Grid
        className="devices-chat-pie"
        sx={{
          height: "318px !important",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Chart
          options={data.options}
          series={series}
          type="pie"
          width={280}
          height={250}
        />
      </Grid>
    </Grid>
  );
}
